module.exports = __webpack_public_path__ + "340e05c1786defbab8ee0960c9dae090.bg_inner.webp";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg_inner.webp
// module id = 761S
// module chunks = 0